// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"cmp-Minicart__section__menuItem","text":"cmp-Minicart__section__text"};